<div class="loading-second" [class.ipm-change-color]="type && type === 'general'" *ngIf="isShowBeatLoading"></div>

<div class="loader-section" *ngIf="!isShowBeatLoading">
    <span class="loader"> </span>
</div>